// Libraries
import { ReactElement, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchOtpReset, sendOtpRequest } from 'src/redux/actions/auth';
import { RootState } from 'src/redux/reducers';
// use slices

// Assets
import { ReactComponent as Logo } from 'src/assets/logo.svg';
import { useHistory } from 'react-router-dom';
import { Navigate } from 'src/routes/constants';
import MobileLogin from './MobileNumber';
import EmailLogin from './Email';
import { HTTP_STATUS } from 'src/constants';
import { reactPagePropsType } from 'src/interfaces/reactPageProps';

// Main Component
const Login = ({ location }: reactPagePropsType): ReactElement => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { search: redirectUrl = '' } = history.location;
  const TOO_MANY_REQUESTS_MESSAGE = 'Too Many Requests, Please try again after some time';
  const Auth = useSelector((state: RootState) => {
    return state.auth;
  });
  const { state: { phoneNumber = '', emailId = '', isEmail = false, error = '' } = {} } = location;

  const loggedIn = useSelector((state: RootState) => {
    return state.login.loggedIn;
  });
  // Internal States
  const [inputNumber, setInputNumber] = useState<string>(phoneNumber);
  const [email, setEmail] = useState<string>(emailId);
  const [isEmailFlow, setIsEmailFlow] = useState<boolean>(isEmail);
  const [isBtnEnable, setIsBtnEnable] = useState<boolean>(false);

  function onSubmit(e: Event): void {
    e.preventDefault();
    setIsBtnEnable(false);
    dispatch(sendOtpRequest(isEmailFlow ? email : inputNumber, isEmailFlow));
  }
  useEffect(() => {
    dispatch(fetchOtpReset());
  }, []);

  if (loggedIn) {
    history.push(Navigate.homescreen);
  }
  useEffect(() => {
    if (Auth.otpFetchStatus && !loggedIn) {
      history.push({
        pathname: `${Navigate.otp}/${isEmailFlow ? email : inputNumber}`,
        search: redirectUrl,
        state: { isEmail: isEmailFlow },
      });
    }
  }, [Auth.otpFetchStatus, loggedIn]);
  return (
    <div className="bg-gray6">
      <div className="min-w-primary phone:max-w-[40%]  min-h-screen mx-auto bg-white  loginwindow">
        <div className="text-center loginbox">
          <div className="flex justify-center pt-4 h-14 mb-10 border-b-2 border-gray6">
            <Logo />
          </div>
          {(Auth.error.code === HTTP_STATUS.FORBIDDEN || error) && (
            <div className="flex justify-center flex-wrap mx-10 text-statusRed">
              {Auth.error.message || error}
            </div>
          )}
          {(Auth.error.code === HTTP_STATUS.TOO_MANY_REQUESTS) && (
            <div className="flex justify-center flex-wrap mx-10 text-statusRed">
              {TOO_MANY_REQUESTS_MESSAGE}
            </div>
          )}
          {!isEmailFlow ? (
            <MobileLogin
              inputNumber={inputNumber}
              setInputNumber={setInputNumber}
              otpRequest={Auth.otpRequest}
              isBtnEnable={isBtnEnable}
              setIsBtnEnable={setIsBtnEnable}
              onSubmit={onSubmit}
            />
          ) : (
            <EmailLogin
              email={email}
              setEmail={setEmail}
              otpRequest={Auth.otpRequest}
              onSubmit={onSubmit}
              isBtnEnable={isBtnEnable}
              setIsBtnEnable={setIsBtnEnable}
            />
          )}
          <div className="mt-8">
            <span
              className="text-primary font-bold text-sm cursor-pointer"
              onClick={(): void => {
                setIsEmailFlow(!isEmailFlow);
                dispatch(fetchOtpReset());
              }}>{`Switch to ${!isEmailFlow ? 'email' : 'mobile number'}`}</span>
          </div>
        </div>
        <div className="flex justify-center text-center p-8 border-t-2 border-gray6 mt-8 sticky top-[100vh]">
          <p className="text-gray7 text-sm">
            By proceeding you agree to our{' '}
            <span
              className="text-primary text-sm font-bold cursor-pointer"
              onClick={(): void => {
                history.push({
                  pathname: Navigate.terms,
                  state: { phoneNumber: inputNumber, emailId: email, isEmail: isEmailFlow },
                });
              }}>
              Terms & conditions
            </span>{' '}
            and get important updates on WhatsApp
          </p>
        </div>
      </div>
    </div>
  );
};

export default Login;
